import Constant from "./headFootConstants";

function getLangKeyValue(resource, key, tplObj = {}): string {
	const { textResults } = resource;
	const keyValues = textResults[key] || {};
	let str = keyValues[Constant.language || "en"];
	/*
		tpl 替换规则
			%key% -> tplObj[key]
	*/
	const tplKeys = Object.keys(tplObj);
	if (tplKeys.length > 0) {
		tplKeys.forEach((key) => {
			const keyReg = new RegExp(`%${key}%`, "gi");
			str = str.replace(keyReg, tplObj[key]);
		});
	}

	return str || key;
}

const defaultBook = { textResults: {} };
export const getLangKeyValueFun = (resource = defaultBook) => {
	const textResults = Object.assign({}, resource.textResults);
	// 根据字典获取一个get value的函数
	const book = Object.assign({}, resource, { textResults });
	return (key, tplObj?) => {
		return getLangKeyValue(book, key, tplObj);
	};
};

export default getLangKeyValueFun;
